import { Navigate, type RouteObject } from 'react-router-dom';

import { Login } from './Login';

export const authRoutes: RouteObject[] = [
  { path: 'login', element: <Login /> },
  { path: '', element: <Navigate to="login" replace /> },
  { path: '*', element: <Navigate to="login" replace /> },
];
